import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { QuestionUuid } from '@/modules/education/v1/api/v1/questions/Dto/QuestionUuid'

/** POST /api/education/v1/questions/{question}/restore: вернуть удалённый вопрос */
export class RestoreQuestionRoute extends EducationRoute<null, QuestionUuid> {
  constructor(private readonly question: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/education/v1/questions/' + this.question + '/restore'
  }

  offline(): Promise<ApiResponse<QuestionUuid>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new QuestionUuid({ uuid: this.question }) }))
  }
}
